
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides/using-the-javascript-sdk",
      function () {
        return require("private-next-pages/guides/using-the-javascript-sdk.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guides/using-the-javascript-sdk"])
      });
    }
  